import type { UseVitalParametersEditorReturn } from 'hooks/useVitalParametersEditor';
import { createEditorContext } from './createEditorContext';

const { Provider, useEditorContext } =
  createEditorContext<UseVitalParametersEditorReturn>('VitalParametersEditor');

export const VitalParametersEditorProvider = Provider;
export const useVitalParametersEditorContext = useEditorContext;
